<header>
  <div class="container">
    <div class="d-flex align-items-center">
      <div class="logo">
        <a (click)="goToPage('shop-fpt')" style="cursor: pointer">
          <img
            src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/logo-80-blue.png"
            alt=""
          />
        </a>
        <span>Nâng cấp dịch vụ</span>
      </div>
      <div class="button-download hide-mobile">
        <button>
          <img
            src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/arrow-down-header-blue.svg"
            alt=""
            width="auto"
            height="auto"
            class="arrow"
          />
          <span>Tải ứng dụng</span>
          <div class="download-option">
            <div class="qr-code">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/qr-code.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
            <div class="button-wrapper">
              <a
                href="https://hi.fpt.vn/rev/lbq/736eyDgY"
                target="_blank"
                class="download"
              >
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/appstore.png"
                  alt=""
                  width="auto"
                  height="auto"
                />
              </a>
              <a
                href="https://hi.fpt.vn/rev/lbq/736eyDgY"
                target="_blank"
                class="download"
              >
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landingpage-hifpt-v7.5/google-play.png"
                  alt=""
                  width="auto"
                  height="auto"
                />
              </a>
            </div>
          </div>
        </button>
      </div>
      <div class="button-download show-mobile">
        <a href="https://hi.fpt.vn/rev/lbq/736eyDgY" target="_blank">
          <img
            src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/arrow-down-header.svg"
            alt=""
            width="auto"
            height="auto"
          />
          <span>Tải App</span>
        </a>
      </div>
    </div>
  </div>
</header>
